import { useTheme } from '@mui/material/styles';
import { WarningIcon } from 'common/icons';
import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  title?: ReactNode;
  description?: ReactNode;
};

export const UnableToLoadContent = ({
  title = 'Unable to load content',
  description = 'Please try again later. If the issue continues, please contact the Engagement Lead or Engagement Manager.',
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const titleI18n = title || t('unableToLoadContent');
  const descriptionI18n = description || t('contactEngagementLead');
  return (
    <Box
      p="1.5rem"
      border={`2px solid ${theme.palette.error.main}`}
      borderRadius="2px"
    >
      <Box mb="1rem" display="flex" alignItems="center">
        <WarningIcon />
        <Box ml="0.5rem" fontWeight="bold" fontSize="1.125rem">
          {titleI18n}
        </Box>
      </Box>
      <Box>{descriptionI18n}</Box>
    </Box>
  );
};
